<template>
    <div class="ah-page remittances-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>銀行匯款明細、匯費</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-form label-position="right" label-width="200px" size="small">
                        <el-form-item label="查詢時間">
                            <el-radio-group v-model="searchDatePreset" size="normal" @change="handlePresetDateChange">
                                <el-radio-button label="today">今日</el-radio-button>
                                <el-radio-button label="week">本週</el-radio-button>
                                <el-radio-button label="prevWeek">上週</el-radio-button>
                                <el-radio-button label="month">本月</el-radio-button>
                                <el-radio-button label="prevMonth">上個月</el-radio-button>
                                <el-radio-button label="custom">自訂範圍</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="日期範圍" v-if="searchDatePreset == 'custom'">
                            <el-date-picker
                                v-model="queryDate"
                                type="daterange"
                                value-format="timestamp"
                                placeholder="選擇日期"
                                :clearable="false"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :default-time="['00:00:00', '23:59:59']"
                                @change="handleDateSpanChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="類型">
                            <el-radio-group v-model="queryParams.TYP" @change="handleTypeChange">
                                <el-radio-button :label="3">全部</el-radio-button>
                                <el-radio-button :label="1">匯出</el-radio-button>
                                <el-radio-button :label="2">匯入</el-radio-button>
                            </el-radio-group>

                            <el-button style="margin-left: 40px" size="mini" @click="toggleAdvSearch">{{ !isShowAdvSearch ? "顯示" : "清除" }}進階搜尋</el-button>
                        </el-form-item>
                        <div v-if="isShowAdvSearch">
                            <el-form-item label="金額範圍">
                                <MoneyInput v-model="queryParams.MinAmt" style="width: 150px" size="small" is-search />
                                <span style="display: inline-block; width: 25px; text-align: center">~</span>
                                <MoneyInput v-model="queryParams.MaxAmt" style="width: 150px" size="small" is-search />
                            </el-form-item>
                            <el-form-item label="對象">
                                <el-input v-model="queryParams.TargetName" style="width: 350px" placeholder="收款人／客戶"></el-input>
                            </el-form-item>
                            <el-form-item label="銀行帳戶">
                                <ahElSelectBankAccount v-model="queryParams.BNK_SNO" :enableNull="true" nullLabel="不限帳戶"></ahElSelectBankAccount>
                            </el-form-item>
                        </div>
                        <el-form-item label="">
                            <el-button v-if="isShowAdvSearch" type="primary" @click="handleSearchBtnClick" style="min-width: 150px" :loading="isLoading">查詢</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header small">
                    <div class="panel-title" style="padding: 15px 35px">
                        查詢結果
                        <span style="font-weight: normal; font-size: 10pt; margin-left: 10px">{{ startDateForDisplay | dateFormater("YYYY 年 MM 月 dd 日") }}</span>
                        <span v-if="searchDatePreset != 'today'">
                            ~
                            <span style="font-weight: normal; font-size: 10pt; margin-left: 10px">{{ endDateForDisplay | dateFormater("YYYY 年 MM 月 dd 日") }}</span>
                        </span>
                    </div>
                    <div class="panel-action">
                        <el-button size="small" type="primary" plain @click="handleExportPayoutExcel" :loading="isExporting">匯出明細(Excel)</el-button>
                    </div>
                </div>
                <div class="ah-statistics-bar" v-if="isLoading == false && datas !== null && datas.length > 0">
                    <div class="item" style="width: 20%"></div>
                    <div class="item stats in sum" style="width: 20%">
                        <span class="label">實際入帳總額</span>
                        <span class="value">
                            <Money v-if="queryParams.TYP !== 1" :v="statisticsInfo.inwardAmount" />
                            <span v-else> --- </span>
                        </span>
                    </div>
                    <div class="item stats in fee" style="width: 20%">
                        <span class="label">匯費(入帳)</span>
                        <template v-if="queryParams.TYP !== 1">
                            <template v-if="statisticsInfo.inwardCurrencyInfos.length > 0">
                                <div v-for="inward in statisticsInfo.inwardCurrencyInfos" :key="`remittances-page-${inward.cny}-inward`" class="flex-block">
                                    <div class="cny">
                                        {{ getCnyText(inward.cny) }}
                                    </div>
                                    ：
                                    <span class="value">
                                        <Money :v="inward.amt" />
                                    </span>
                                </div>
                            </template>
                            <span v-else class="value">
                                <Money :v="0" />
                            </span>
                        </template>
                        <span class="value" v-else> --- </span>
                    </div>
                    <div class="divider"></div>
                    <div class="item stats out sum" style="width: 20%">
                        <span class="label">實際匯出總額</span>
                        <span class="value">
                            <Money v-if="queryParams.TYP !== 2" :v="statisticsInfo.outwardAmount" />
                            <span v-else> --- </span>
                        </span>
                    </div>
                    <div class="item stats out fee" style="width: 20%">
                        <span class="label">匯費(匯出)</span>
                        <template v-if="queryParams.TYP !== 2">
                            <template v-if="statisticsInfo.outwardCurrencyInfos.length > 0">
                                <div v-for="outward in statisticsInfo.outwardCurrencyInfos" :key="`remittances-page-${outward.cny}-outward`" class="flex-block">
                                    <div class="cny">
                                        {{ getCnyText(outward.cny) }}
                                    </div>
                                    ：
                                    <span class="value">
                                        <Money :v="outward.amt" />
                                    </span>
                                </div>
                            </template>
                            <span v-else class="value">
                                <Money :v="0" />
                            </span>
                        </template>
                        <span class="value" v-else> --- </span>
                    </div>
                </div>
                <div class="panel-body">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        small
                        @current-change="updateData()"
                        class="pagination top"
                    >
                    </el-pagination>
                    <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料" row-class-name="first-level-row" @sort-change="onSortChange">
                        <el-table-column type="expand" width="50" style="background-color: red">
                            <template slot-scope="scope">
                                <InvoiceIncomeTable v-if="isInvoiceIncomeData(scope.row)" :data="scope.row.invoiceItems" @row-click="handleInvoiceItemClick" />
                                <InvoiceRefundTable v-else-if="isInvoiceRefundData(scope.row)" :data="scope.row.invoiceItems" @row-click="handleInvoiceItemClick" />
                                <PaymentTable v-else-if="isPaymentData(scope.row)" :data="scope.row.payoutItems" :getPaymentTypeName="getPaymentTypeName" @row-click="handlePaymentItemClick" />
                                <VariableTable v-else-if="isVariableData(scope.row)" :data="scope.row.variableItems" :getPaymentTypeName="getPaymentTypeName" @row-click="onVariableItemClick" />
                            </template>
                        </el-table-column>
                        <el-table-column label="單據" width="55">
                            <template slot-scope="scope">
                                <span v-if="isPaymentData(scope.row)"> {{ scope.row.payoutItems.length }} 筆 </span>
                                <span v-else-if="isVariableData(scope.row)"> {{ scope.row.variableItems.length }} 筆 </span>
                                <span v-else> {{ scope.row.invoiceItems.length }} 筆 </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="typ" label="類型" width="80" sortable="custom">
                            <template slot-scope="scope">
                                <div>
                                    <span class="ah-status income" v-if="scope.row.typ === 2">匯入 </span>
                                    <span class="ah-status payout" v-if="scope.row.typ === 1">匯出 </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="account" label="銀行帳戶" width="180" :sortable="queryParams.TYP === 3 ? false : 'custom'">
                            <template slot-scope="scope">
                                <span class="strong">{{ scope.row.A }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="60" align="center">
                            <template slot-scope="scope">
                                <span v-if="isIncome(scope.row)">
                                    <i class="el-icon-back" />
                                </span>
                                <span v-else>
                                    <i class="el-icon-right" />
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="others" :label="targetLabel" :sortable="queryParams.TYP === 3 ? false : 'custom'">
                            <template slot-scope="scope">
                                <div class="strong">{{ scope.row.B }}</div>
                                <div v-if="getShowType(scope.row) === 'bank-info' && isBankInfoIntact(scope.row)">
                                    <template v-if="!isUnknownBnkInfo(scope.row)">
                                        <div>戶名：{{ scope.row.vdR_BNK_TPC }}</div>
                                        <div>
                                            <span>銀行：</span>
                                            <span>({{ scope.row.targeT_BNK_BOO }})</span>
                                            <span> {{ scope.row.targeT_BNK_DOO_NAM }}</span>
                                        </div>
                                        <div v-if="scope.row.targeT_BNK_DOO">分行代碼：{{ scope.row.targeT_BNK_DOO }}</div>
                                        <div>帳號：{{ scope.row.vdR_BNK_ACC }}</div>
                                    </template>
                                </div>
                                <div v-else-if="getShowType(scope.row) === 'bank-info' && isInternationalTransfer(scope.row)">
                                    <div>境外匯款</div>
                                    <div>戶名：{{ scope.row.vdR_BNK_TPC }}</div>
                                    <div>帳號：{{ scope.row.vdR_BNK_ACC }}</div>
                                </div>
                                <div v-else-if="scope.row.B && getShowType(scope.row) === 'bank-deposit-payment'">銀行提現付款</div>
                                <div v-else-if="!scope.row.B"> --- </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dat" :label="dateLabel" width="120" sortable="custom">
                            <template slot-scope="scope">
                                <span class="idx">
                                    {{ scope.row.dat | dateFormater("YYYY-MM-dd") }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sum" label="金額" align="right" width="150" sortable="custom">
                            <template slot-scope="scope">
                                <Money :v="scope.row.sum" :precision="scope.row.cnynam === '新台幣' ? null : 4" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="cny" label="幣別" width="80" align="center" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.cnynam }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="feE_AMT" label="匯費" align="right" width="70">
                            <template slot-scope="scope">
                                <Money :v="scope.row.feE_AMT" :precision="scope.row.cnynam === '新台幣' ? null : 4" />
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="105">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="handleFeeBtnClick(scope.row)">填寫匯費</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="updateData()"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <InvoiceDetailDialog ref="invoiceDetailDialog" @close="handleInvoiceDetailDialogClose" :sno="invoiceDetailDialog.sno" :visible="invoiceDetailDialog.visible" />
        <PaymentDetailDialog ref="paymentDetailDialog" @close="handlePaymentDetailDialogClose" :sno="paymentDetailDialog.sno" :visible="paymentDetailDialog.visible" />
        <FeeDialog ref="feeDialog" @close="handleFeeDialogClose" :visible="feeDialog.visible" :sno="feeDialog.sno" :amt="feeDialog.amt" :cny="feeDialog.cny" :rat="feeDialog.rat" />
        <VariableDetailDialog ref="variableDetailDialog" :sno="variableDetailDialog.sno" :visible="variableDetailDialog.visible" @edit="onEditDialogVisibleChange" @close="onDetailDialogClose" />
        <VariableEditDialog
            :sno="variableEditDialog.sno"
            :visible="variableEditDialog.visible"
            :purpose="variableEditDialog.purpose"
            @refresh="onEditDialogRefresh"
            @close="onEditDialogVisibleChange"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import qs from 'qs';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import moment from 'moment';
import { paymentType, cnyName } from '@/assets/commonData/options';
import VariableDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import VariableEditDialog from '@/components/dashboard/Finance/VariableStatement/EditDialog.vue';
import FeeDialog from './FeeDialog.vue';
import InvoiceIncomeTable from './InvoiceIncomeTable.vue';
import PaymentTable from './PaymentTable.vue';
import InvoiceRefundTable from './InvoiceRefundTable.vue';
import VariableTable from './VariableTable.vue';

export default {
    name: 'RemittancesIndex',
    components: {
        InvoiceDetailDialog,
        PaymentDetailDialog,
        FeeDialog,
        ahElSelectBankAccount,
        InvoiceIncomeTable,
        PaymentTable,
        InvoiceRefundTable,
        VariableTable,
        VariableDetailDialog,
        VariableEditDialog,
    },
    data() {
        return {
            isExporting: false,
            queryParams: {
                TYP: 1,
                PDAT_Start: null,
                PDAT_End: null,
                MinAmt: null,
                MaxAmt: null,
                TargetName: null,
                BNK_SNO: null,
                PageSize: 25,
                PageNum: 1,
                SortProperties: {
                    Name: null,
                    IsDescending: true,
                },
            },
            statisticsInfo: {
                inwardAmount: null,
                inwardCurrencyInfos: null,
                outwardAmount: null,
                outwardCurrencyInfos: null,
            },
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            variableDetailDialog: {
                visible: false,
                sno: null,
            },
            variableEditDialog: {
                visible: false,
                purpose: null,
                sno: null,
            },
            feeDialog: {
                visible: false,
                sno: null,
                amt: null,
                cny: null,
            },
            searchDatePreset: 'today',
            queryDate: null,
            isLoading: false,
            isShowAdvSearch: false,
            totalDataCount: 0,
            datas: [],
        };
    },
    mounted() {
        if (this.$route.query.searchDatePreset) {
            this.searchDatePreset = this.$route.query.searchDatePreset;
        }
        if (this.$route.query.searchDatePreset === 'custom') {
            const startDate = Number.parseInt(this.$route.query.PDAT_Start, 10);
            const endDate = Number.parseInt(this.$route.query.PDAT_End, 10);
            if (startDate && endDate) {
                this.queryParams.PDAT_Start = startDate;
                this.queryParams.PDAT_End = endDate;
                this.queryDate = [startDate, endDate];
            }
        }
        if (this.$route.query.TYP) {
            this.queryParams.TYP = Number.parseInt(this.$route.query.TYP, 10);
        }
        if (this.$route.query.PageNum) {
            this.queryParams.PageNum = Number.parseInt(this.$route.query.PageNum, 10);
        }

        if (this.$route.query.MinAmt) {
            this.queryParams.MinAmt = Number.parseInt(this.$route.query.MinAmt, 10);
        }
        if (this.$route.query.MaxAmt) {
            this.queryParams.MaxAmt = Number.parseInt(this.$route.query.MaxAmt, 10);
        }
        if (this.$route.query.TargetName) {
            this.queryParams.TargetName = this.$route.query.TargetName;
        }
        if (this.$route.query.BNK_SNO) {
            this.queryParams.BNK_SNO = this.$route.query.BNK_SNO;
        }

        if (this.$route.query.MinAmt
            || this.$route.query.MaxAmt
            || this.$route.query.TargetName
            || this.$route.query.BNK_SNO
        ) {
            this.isShowAdvSearch = true;
        }

        this.updateData();
    },
    computed: {
        startDateForDisplay() {
            if (this.queryParams.PDAT_Start) {
                return new Date(this.queryParams.PDAT_Start);
            }
            return null;
        },
        endDateForDisplay() {
            if (this.queryParams.PDAT_End) {
                return new Date(this.queryParams.PDAT_End);
            }
            return null;
        },
        targetLabel() {
            if (this.queryParams.TYP === 1) return '收款人';
            if (this.queryParams.TYP === 2) return '客戶';
            if (this.queryParams.TYP === 3) return '收款人 / 客戶';
            return '';
        },
        dateLabel() {
            if (this.queryParams.TYP === 1) return '付款日';
            if (this.queryParams.TYP === 2) return '收款日';
            if (this.queryParams.TYP === 3) return '付/收款日';
            return '';
        },
    },
    methods: {
        handleExportPayoutExcel() {
            this.fetchDataForExport().then((resp) => {
                const { items } = resp.data;
                const wb = MyXLSX2.createBook();

                if (this.queryParams.TYP === 1) {
                    const paymentSumSheet = this.getPaymentSumSheet(items);
                    const paymentDetailSheet = this.getPaymentDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, paymentSumSheet, '請款單-彙總');
                    MyXLSX2.bookAppendSheet(wb, paymentDetailSheet, '請款單-明細');

                    const refundSumSheet = this.getRefundSumSheet(items);
                    const refundDetailSheet = this.getRefundDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, refundSumSheet, '發票(退款)-彙總');
                    MyXLSX2.bookAppendSheet(wb, refundDetailSheet, '發票(退款)-明細');

                    const variableStatementPayoutSumSheet = this.getVariableStatementPayoutSumSheet(items);
                    const variableStatementDetailPayoutSheet = this.getVariableStatementPayoutDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, variableStatementPayoutSumSheet, '財務支出-彙總');
                    MyXLSX2.bookAppendSheet(wb, variableStatementDetailPayoutSheet, '財務支出-明細');
                }
                if (this.queryParams.TYP === 2) {
                    const sumSheet = this.getInvoiceSumSheet(items);
                    const detailSheet = this.getInvoiceDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, sumSheet, '發票-彙總');
                    MyXLSX2.bookAppendSheet(wb, detailSheet, '發票-明細');

                    const variableStatementIncomeSumSheet = this.getVariableStatementIncomeSumSheet(items);
                    const variableStatementIncomeDetailSheet = this.getVariableStatementIncomeDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, variableStatementIncomeSumSheet, '財務收入-彙總');
                    MyXLSX2.bookAppendSheet(wb, variableStatementIncomeDetailSheet, '財務收入-明細');
                }
                if (this.queryParams.TYP === 3) {
                    const paymentSumSheet = this.getPaymentSumSheet(items);
                    const paymentDetailSheet = this.getPaymentDetailSheet(items);
                    const invoiceSumSheet = this.getInvoiceSumSheet(items);
                    const invoiceDetailSheet = this.getInvoiceDetailSheet(items);
                    const refundSumSheet = this.getRefundSumSheet(items);
                    const refundDetailSheet = this.getRefundDetailSheet(items);
                    const variableStatementPayoutSumSheet = this.getVariableStatementPayoutSumSheet(items);
                    const variableStatementDetailPayoutSheet = this.getVariableStatementPayoutDetailSheet(items);
                    const variableStatementIncomeSumSheet = this.getVariableStatementIncomeSumSheet(items);
                    const variableStatementIncomeDetailSheet = this.getVariableStatementIncomeDetailSheet(items);
                    MyXLSX2.bookAppendSheet(wb, paymentSumSheet, '請款單-彙總');
                    MyXLSX2.bookAppendSheet(wb, paymentDetailSheet, '請款單-明細');
                    MyXLSX2.bookAppendSheet(wb, invoiceSumSheet, '發票-彙總');
                    MyXLSX2.bookAppendSheet(wb, invoiceDetailSheet, '發票-明細');
                    MyXLSX2.bookAppendSheet(wb, refundSumSheet, '發票(退款)-彙總');
                    MyXLSX2.bookAppendSheet(wb, refundDetailSheet, '發票(退款)-明細');
                    MyXLSX2.bookAppendSheet(wb, variableStatementPayoutSumSheet, '財務支出-彙總');
                    MyXLSX2.bookAppendSheet(wb, variableStatementDetailPayoutSheet, '財務支出-明細');
                    MyXLSX2.bookAppendSheet(wb, variableStatementIncomeSumSheet, '財務收入-彙總');
                    MyXLSX2.bookAppendSheet(wb, variableStatementIncomeDetailSheet, '財務收入-明細');
                }
                MyXLSX2.download(wb, `${this.getExportFileName()}.xlsx`);
            });
        },
        getPaymentSumSheet(datas) {
            const title = '匯款明細查詢 - 請款單彙總';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '收款人', width: 35, align: 'left' },
                { text: '收款銀行', width: 35, align: 'left' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款戶名', width: 35, align: 'left' },
                { text: '收款帳號', width: 25, align: 'left' },
                { text: '付款帳戶', width: 25, align: 'left' },
                { text: '付款日', width: 13, align: 'center' },
                {
                    text: '實付金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '匯費',
                    width: 8,
                    align: 'right',
                    number: true,
                },
                {
                    text: '支出合計',
                    width: 10,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯費匯率', width: 10, align: 'right' },
                { text: '匯費約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            const feeSum = {};
            let n = 1;
            for (let i = 0; i < datas.length; i += 1) {
                const tradeSumUp = datas[i];
                if (tradeSumUp.typ === 1 && tradeSumUp.payoutItems.length) {
                    let targetBank = `(${tradeSumUp.targeT_BNK_BOO}) ${tradeSumUp.targeT_BNK_DOO_NAM}`;
                    if (tradeSumUp.targeT_BNK_DOO_NAM === null) {
                        targetBank = '';
                    }

                    // 1 = 匯出
                    const CNY = this.cnyNameToCny(tradeSumUp.cnynam);
                    const row = [
                        n,
                        '匯出', // 類型
                        tradeSumUp.payoutItems.length, // 筆數
                        tradeSumUp.tageT_NAM || '', // 收款對象
                        targetBank, // 收款對象銀行
                        tradeSumUp.targeT_BNK_BOO || '', // 收款銀行代碼
                        this.getBnkDoo(tradeSumUp.targeT_BNK_DOO), // 收款分行代碼
                        tradeSumUp.vdR_BNK_TPC || '', // 收款對象戶名
                        tradeSumUp.vdR_BNK_ACC || '', // 收款對象帳號
                        tradeSumUp.froM_BNK_TPC || '', // 銀行帳戶
                        moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 付款日
                        tradeSumUp.sum || 0, // 金額
                        tradeSumUp.feE_AMT || 0, // 匯費
                        (tradeSumUp.feE_AMT || 0) + (tradeSumUp.sum || 0), // 支出合計
                        CNY || '', // 幣別
                        tradeSumUp.rat, // 匯費匯率
                        Math.round(tradeSumUp.feE_AMT * tradeSumUp.rat), // 匯費約當台幣
                    ];
                    bodyRows.push(row);
                    n += 1;

                    // 分幣別的總金額
                    sumByCny[CNY] += (tradeSumUp.feE_AMT || 0) + (tradeSumUp.sum || 0);

                    // 計算各幣別匯費
                    if (!feeSum[CNY]) feeSum[CNY] = 0;
                    feeSum[CNY] += Number(tradeSumUp.feE_AMT);
                }
            }
            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny, '付款總金額'));
            _.forEach(feeSum, (value, key) => {
                headRows.push({ label: `匯費 (${key})`, value });
            });

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getPaymentDetailSheet(datas) {
            const title = '匯款明細查詢 - 請款單明細';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '請款類型', width: 15, align: 'center' },
                { text: '單號', width: 18, align: 'center' },
                { text: '摘要', width: 45, align: 'left' },
                { text: '收款人', width: 25, align: 'left' },
                { text: '收款銀行', width: 35, align: 'left' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款戶名', width: 35, align: 'left' },
                { text: '收款帳號', width: 25, align: 'left' },
                { text: '付款帳戶', width: 35, align: 'left' },
                { text: '付款日', width: 13, align: 'center' },
                {
                    text: '帳款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '實付金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            let n = 1;
            for (let i = 0; i < datas.length; i += 1) {
                const tradeSumUp = datas[i];
                if (tradeSumUp.typ === 1) {
                    let targetBank = `(${tradeSumUp.targeT_BNK_BOO}) ${tradeSumUp.targeT_BNK_DOO_NAM}`;
                    if (tradeSumUp.targeT_BNK_DOO_NAM === null) {
                        targetBank = '';
                    }

                    // 1 = 匯出
                    for (let j = 0; j < tradeSumUp.payoutItems.length; j += 1) {
                        const item = tradeSumUp.payoutItems[j];
                        const row = [
                            n,
                            '請款單',
                            this.getPaymentTypeName(item.paymentType),
                            item.payoo || '', // 單號
                            item.nam || '', // 摘要
                            tradeSumUp.tageT_NAM || '', // 對象
                            targetBank, // 收款對象銀行
                            tradeSumUp.targeT_BNK_BOO || '', // 收款銀行代碼
                            this.getBnkDoo(tradeSumUp.targeT_BNK_DOO), // 收款分行代碼
                            tradeSumUp.vdR_BNK_TPC || '', // 收款對象戶名
                            tradeSumUp.vdR_BNK_ACC || '', // 收款對象帳號
                            tradeSumUp.froM_BNK_TPC || '', // 付款帳戶
                            /* tradeSumUp.targeT_BNK_BOO
                                ? `${tradeSumUp.targeT_BNK_BOO} - ${tradeSumUp.targeT_BNK_DOO_NAM}`
                                : '', // 收款帳戶 */
                            moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 付款日
                            item.amt || 0, // 帳款金額
                            item.actuallyAmt || 0, // 實付金額
                            item.cny || '', // 幣別
                            item.rat, // 匯率
                            Math.round(item.amt * item.rat), // 約當台幣
                        ];
                        bodyRows.push(row);
                        n += 1;

                        // 分幣別的總金額
                        sumByCny[item.cny] += item.actuallyAmt;
                    }
                }
            }

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny));

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getInvoiceSumSheet(datas) {
            const title = '匯款明細查詢 - 發票彙總';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '客戶', width: 35, align: 'left' },
                { text: '收款帳戶', width: 35, align: 'left' },
                { text: '收款日', width: 13, align: 'center' },
                {
                    text: '收款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '匯費',
                    width: 8,
                    align: 'right',
                    number: true,
                },
                {
                    text: '收入合計',
                    width: 10,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯費匯率', width: 10, align: 'right' },
                { text: '匯費約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            const feeSum = {};
            let n = 1;
            for (let i = 0; i < datas.length; i += 1) {
                const tradeSumUp = datas[i];
                if (tradeSumUp.typ === 2 && tradeSumUp.invoiceItems.length) {
                    // 2 = 匯入
                    const CNY = this.cnyNameToCny(tradeSumUp.cnynam);
                    const row = [
                        n,
                        '匯入', // 類型
                        tradeSumUp.invoiceItems.length, // 筆數
                        tradeSumUp.froM_BNK_TPC || '', // 客戶
                        tradeSumUp.tageT_NAM || '', // 收款帳戶
                        /* tradeSumUp.targeT_BNK_BOO
                            ? `${tradeSumUp.targeT_BNK_BOO} - ${tradeSumUp.targeT_BNK_DOO_NAM}`
                            : '', // 付款銀行分行 */
                        moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 收款日
                        tradeSumUp.sum || 0, // 收款金額
                        tradeSumUp.feE_AMT || 0, // 匯費
                        (tradeSumUp.sum || 0) - (tradeSumUp.feE_AMT || 0), // 收入合計
                        CNY || '', // 幣別
                        tradeSumUp.rat, // 匯費匯率
                        Math.round(tradeSumUp.feE_AMT * tradeSumUp.rat), // 匯費約當台幣
                    ];
                    bodyRows.push(row);
                    n += 1;

                    // 分幣別的總金額
                    sumByCny[CNY] += (tradeSumUp.sum || 0) - (tradeSumUp.feE_AMT || 0);

                    // 計算各幣別匯費
                    if (!feeSum[CNY]) feeSum[CNY] = 0;
                    feeSum[CNY] += Number(tradeSumUp.feE_AMT);
                }
            }
            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny, '收款總金額'));
            _.forEach(feeSum, (value, key) => {
                headRows.push({ label: `匯費 (${key})`, value });
            });

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getInvoiceDetailSheet(datas) {
            const title = '匯款明細查詢 - 發票明細';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 15, align: 'center' },
                { text: '單號', width: 18, align: 'center' },
                { text: '客戶', width: 35, align: 'left' },
                { text: '摘要', width: 45, align: 'left' },
                { text: '收款帳戶', width: 35, align: 'left' },
                { text: '收款日', width: 13, align: 'center' },
                {
                    text: '收款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            let n = 1;
            for (let i = 0; i < datas.length; i += 1) {
                const tradeSumUp = datas[i];
                if (tradeSumUp.typ === 2) {
                    // 2 = 匯入
                    for (let j = 0; j < tradeSumUp.invoiceItems.length; j += 1) {
                        const item = tradeSumUp.invoiceItems[j];
                        const row = [
                            n,
                            '發票',
                            item.ioo || '', // 單號
                            item.fnam || '', // 客戶
                            item.description || '', // 摘要
                            tradeSumUp.tageT_NAM || '', // 收款帳戶
                            /* tradeSumUp.targeT_BNK_BOO
                                ? `${tradeSumUp.targeT_BNK_BOO} - ${tradeSumUp.targeT_BNK_DOO_NAM}`
                                : '', // 付款銀行分行 */
                            moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 收款日
                            item.incomeAmount || 0, // 收款金額
                            item.cny || '', // 幣別
                            item.rat, // 匯率
                            Math.round(item.amt * item.rat), // 約當台幣
                        ];
                        bodyRows.push(row);
                        n += 1;

                        // 分幣別的總金額
                        sumByCny[item.cny] += item.incomeAmount;
                    }
                }
            }

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny));

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getRefundSumSheet(datas) {
            const title = '匯款明細查詢 - 發票(退款)彙總';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '客戶', width: 35, align: 'left' },
                { text: '銀行帳戶', width: 35, align: 'left' },
                { text: '退款日', width: 13, align: 'center' },
                {
                    text: '退款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '匯費',
                    width: 8,
                    align: 'right',
                    number: true,
                },
                {
                    text: '支出合計',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯費匯率', width: 10, align: 'right' },
                { text: '匯費約當台幣', width: 15, align: 'right' },
            ];

            // 內容資料
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });

            let indexN = 1;
            const feeSum = {};
            datas.forEach((data) => {
                if (data.typ === 1 && data.invoiceItems.length) {
                    const CNY = this.cnyNameToCny(data.cnynam);
                    const row = [
                        indexN,
                        '匯出', // 類型
                        data.invoiceItems.length, // 筆數
                        data.froM_BNK_TPC || '', // 客戶
                        data.tageT_NAM || '', // 收款帳戶
                        moment(data.dat).format('YYYY-MM-DD') || '', // 收款日
                        data.sum || 0, // 收款金額
                        data.feE_AMT || 0, // 匯費
                        (data.feE_AMT || 0) + (data.sum || 0), // 支出合計
                        CNY || '', // 幣別
                        data.rat, // 匯費匯率
                        Math.round(data.feE_AMT * data.rat), // 匯費約當台幣
                    ];
                    bodyRows.push(row);
                    indexN += 1;

                    // 分幣別的總金額
                    sumByCny[CNY] += (data.feE_AMT || 0) + (data.sum || 0);

                    // 計算各幣別匯費
                    if (!feeSum[CNY]) feeSum[CNY] = 0;
                    feeSum[CNY] += Number(data.feE_AMT);
                }
            });

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny, '付款總金額'));
            _.forEach(feeSum, (value, key) => {
                headRows.push({ label: `匯費 (${key})`, value });
            });

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getRefundDetailSheet(datas) {
            const title = '匯款明細查詢 - 發票(退款)明細';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 15, align: 'center' },
                { text: '單號', width: 18, align: 'center' },
                { text: '退款存簿戶名', width: 35, align: 'left' },
                { text: '摘要', width: 45, align: 'left' },
                { text: '退款帳戶', width: 35, align: 'left' },
                { text: '退款日', width: 13, align: 'center' },
                {
                    text: '退款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });

            let indexN = 1;
            datas.forEach((data) => {
                if (data.typ === 1 && data.invoiceItems.length) {
                    data.invoiceItems.forEach((item) => {
                        const row = [
                            indexN,
                            '發票(退款)',
                            item.ioo || '', // 單號
                            item.fnam || '', // 客戶
                            item.description || '', // 摘要
                            data.tageT_NAM || '', // 收款帳戶
                            moment(data.dat).format('YYYY-MM-DD') || '', // 收款日
                            item.incomeAmount || 0, // 收款金額
                            item.cny || '', // 幣別
                            item.rat, // 匯率
                            Math.round(item.amt * item.rat), // 約當台幣
                        ];
                        bodyRows.push(row);
                        indexN += 1;

                        // 分幣別的總金額
                        sumByCny[item.cny] += item.incomeAmount;
                    });
                }
            });

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny));

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getVariableStatementPayoutSumSheet(datas) {
            const DATA = _.filter(datas, ['typ', 1]);
            const title = '匯款明細查詢 - 財務支出彙總';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '收款人', width: 35, align: 'left' },
                { text: '收款銀行', width: 35, align: 'left' },
                { text: '收款戶名', width: 35, align: 'left' },
                { text: '收款帳號', width: 25, align: 'left' },
                { text: '付款帳戶', width: 25, align: 'left' },
                { text: '付款日', width: 13, align: 'center' },
                {
                    text: '實付金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '匯費',
                    width: 8,
                    align: 'right',
                    number: true,
                },
                {
                    text: '支出合計',
                    width: 10,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯費匯率', width: 10, align: 'right' },
                { text: '匯費約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            const feeSum = {};
            let n = 1;
            for (let i = 0; i < DATA.length; i += 1) {
                const tradeSumUp = DATA[i];
                if (tradeSumUp.typ === 1 && tradeSumUp.variableItems.length) {
                    let targetBank = `(${tradeSumUp.targeT_BNK_BOO}) ${tradeSumUp.targeT_BNK_DOO_NAM}`;
                    if (tradeSumUp.targeT_BNK_DOO_NAM === null) {
                        targetBank = '';
                    }

                    // 1 = 匯出
                    const CNY = this.cnyNameToCny(tradeSumUp.cnynam);
                    const row = [
                        n,
                        '匯出', // 類型
                        tradeSumUp.variableItems.length, // 筆數
                        tradeSumUp.tageT_NAM || '', // 收款對象
                        targetBank, // 收款對象銀行
                        tradeSumUp.vdR_BNK_TPC || '', // 收款對象戶名
                        tradeSumUp.vdR_BNK_ACC || '', // 收款對象帳號
                        tradeSumUp.froM_BNK_TPC || '', // 銀行帳戶
                        moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 付款日
                        tradeSumUp.sum || 0, // 金額
                        tradeSumUp.feE_AMT || 0, // 匯費
                        (tradeSumUp.feE_AMT || 0) + (tradeSumUp.sum || 0), // 支出合計
                        CNY || '', // 幣別
                        tradeSumUp.rat, // 匯費匯率
                        Math.round(tradeSumUp.feE_AMT * tradeSumUp.rat), // 匯費約當台幣
                    ];
                    bodyRows.push(row);
                    n += 1;

                    // 分幣別的總金額
                    sumByCny[CNY] += (tradeSumUp.feE_AMT || 0) + (tradeSumUp.sum || 0);

                    // 計算各幣別匯費
                    if (!feeSum[CNY]) feeSum[CNY] = 0;
                    feeSum[CNY] += Number(tradeSumUp.feE_AMT);
                }
            }
            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny, '付款總金額'));
            _.forEach(feeSum, (value, key) => {
                headRows.push({ label: `匯費 (${key})`, value });
            });

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getVariableStatementPayoutDetailSheet(datas) {
            const DATA = _.filter(datas, ['typ', 1]);
            const title = '匯款明細查詢 - 財務支出明細';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '單號', width: 18, align: 'center' },
                { text: '摘要', width: 45, align: 'left' },
                { text: '收款人', width: 25, align: 'left' },
                { text: '收款銀行', width: 35, align: 'left' },
                { text: '收款戶名', width: 35, align: 'left' },
                { text: '收款帳號', width: 25, align: 'left' },
                { text: '付款帳戶', width: 35, align: 'left' },
                { text: '付款日', width: 13, align: 'center' },
                {
                    text: '金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            let n = 1;
            for (let i = 0; i < DATA.length; i += 1) {
                const tradeSumUp = DATA[i];
                if (tradeSumUp.typ === 1) {
                    let targetBank = `(${tradeSumUp.targeT_BNK_BOO}) ${tradeSumUp.targeT_BNK_DOO_NAM}`;
                    if (tradeSumUp.targeT_BNK_DOO_NAM === null) {
                        targetBank = '';
                    }

                    for (let j = 0; j < tradeSumUp.variableItems.length; j += 1) {
                        const item = tradeSumUp.variableItems[j];
                        const row = [
                            n,
                            '財務單',
                            item.moo || '', // 單號
                            item.tpc || '', // 摘要
                            tradeSumUp.tageT_NAM || '', // 對象
                            targetBank, // 收款對象銀行
                            tradeSumUp.vdR_BNK_TPC || '', // 收款對象戶名
                            tradeSumUp.vdR_BNK_ACC || '', // 收款對象帳號
                            tradeSumUp.froM_BNK_TPC || '', // 付款帳戶
                            moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 付款日
                            item.amt || 0, // 帳款金額
                            item.cny || '', // 幣別
                            item.rat, // 匯率
                            Math.round(item.amt * item.rat), // 約當台幣
                        ];
                        bodyRows.push(row);
                        n += 1;

                        // 分幣別的總金額
                        sumByCny[item.cny] += item.amt;
                    }
                }
            }

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny));

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getVariableStatementIncomeSumSheet(datas) {
            const DATA = _.filter(datas, ['typ', 2]);
            const title = '匯款明細查詢 - 財務收入彙總';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 12, align: 'center' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '客戶', width: 35, align: 'left' },
                { text: '收款帳戶', width: 35, align: 'left' },
                { text: '收款日', width: 13, align: 'center' },
                {
                    text: '收款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                {
                    text: '匯費',
                    width: 8,
                    align: 'right',
                    number: true,
                },
                {
                    text: '收入合計',
                    width: 10,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯費匯率', width: 10, align: 'right' },
                { text: '匯費約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            const feeSum = {};
            let n = 1;
            for (let i = 0; i < DATA.length; i += 1) {
                const tradeSumUp = DATA[i];
                if (tradeSumUp.typ === 2 && tradeSumUp.variableItems.length) {
                    // 2 = 匯入
                    const CNY = this.cnyNameToCny(tradeSumUp.cnynam);
                    const row = [
                        n,
                        '匯入', // 類型
                        tradeSumUp.variableItems.length, // 筆數
                        tradeSumUp.froM_BNK_TPC || '', // 客戶
                        tradeSumUp.tageT_NAM || '', // 收款帳戶
                        /* tradeSumUp.targeT_BNK_BOO
                            ? `${tradeSumUp.targeT_BNK_BOO} - ${tradeSumUp.targeT_BNK_DOO_NAM}`
                            : '', // 付款銀行分行 */
                        moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 收款日
                        tradeSumUp.sum || 0, // 收款金額
                        tradeSumUp.feE_AMT || 0, // 匯費
                        (tradeSumUp.sum || 0) - (tradeSumUp.feE_AMT || 0), // 收入合計
                        CNY || '', // 幣別
                        tradeSumUp.rat, // 匯費匯率
                        Math.round(tradeSumUp.feE_AMT * tradeSumUp.rat), // 匯費約當台幣
                    ];
                    bodyRows.push(row);
                    n += 1;

                    // 分幣別的總金額
                    sumByCny[CNY] += (tradeSumUp.sum || 0) - (tradeSumUp.feE_AMT || 0);

                    // 計算各幣別匯費
                    if (!feeSum[CNY]) feeSum[CNY] = 0;
                    feeSum[CNY] += Number(tradeSumUp.feE_AMT);
                }
            }
            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny, '收款總金額'));
            _.forEach(feeSum, (value, key) => {
                headRows.push({ label: `匯費 (${key})`, value });
            });

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getVariableStatementIncomeDetailSheet(datas) {
            const DATA = _.filter(datas, ['typ', 2]);
            const title = '匯款明細查詢 - 財務收入明細';
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '類型', width: 15, align: 'center' },
                { text: '單號', width: 18, align: 'center' },
                { text: '付款銀行', width: 35, align: 'left' },
                { text: '付款戶名', width: 35, align: 'left' },
                { text: '付款帳號', width: 25, align: 'left' },
                { text: '摘要', width: 45, align: 'left' },
                { text: '收款帳戶', width: 35, align: 'left' },
                { text: '收款日', width: 13, align: 'center' },
                {
                    text: '收款金額',
                    width: 15,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', width: 10, align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', width: 15, align: 'right' },
            ];
            const bodyRows = [];
            const sumByCny = {};
            _.forEach(cnyName, (o, i) => {
                sumByCny[i] = 0;
            });
            let n = 1;
            for (let i = 0; i < DATA.length; i += 1) {
                const tradeSumUp = DATA[i];
                if (tradeSumUp.typ === 2) {
                    let targetBank = `(${tradeSumUp.targeT_BNK_BOO}) ${tradeSumUp.targeT_BNK_DOO_NAM}`;
                    if (tradeSumUp.targeT_BNK_DOO_NAM === null) targetBank = '';

                    // 2 = 匯入
                    for (let j = 0; j < tradeSumUp.variableItems.length; j += 1) {
                        const item = tradeSumUp.variableItems[j];
                        const row = [
                            n,
                            '財務單',
                            item.moo || '', // 單號
                            targetBank || '', // 付款銀行
                            item.vdR_BNK_TPC || '', // 付款戶名
                            item.vdR_BNK_ACC || '', // 付款帳號
                            item.tpc || '', // 摘要
                            tradeSumUp.froM_BNK_TPC || '', // 收款帳戶
                            moment(tradeSumUp.dat).format('YYYY-MM-DD') || '', // 收款日
                            item.amt || 0, // 收款金額
                            item.cny || '', // 幣別
                            item.rat, // 匯率
                            Math.round(item.amt * item.rat), // 約當台幣
                        ];
                        bodyRows.push(row);
                        n += 1;

                        // 分幣別的總金額
                        sumByCny[item.cny] += item.amt;
                    }
                }
            }

            // 自訂匯總資訊
            const sd = moment(this.startDateForDisplay).format('YYYY-MM-DD');
            const ed = moment(this.endDateForDisplay).format('YYYY-MM-DD');
            const cd = moment().format('YYYY-MM-DD');
            let headRows = [
                { label: '查詢區間', value: `${sd} 至 ${ed}` },
                { label: '製表日期', value: cd },
            ];
            headRows = headRows.concat(this.cnySumToHeadRows(sumByCny));

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getBnkDoo(doo) {
            if (doo === '700') return '0021';
            return doo ? doo.substring(3) : '';
        },

        cnySumToHeadRows(sumByCny, label = '總金額') {
            const rows = [];
            _.forEach(cnyName, (o, i) => {
                if (sumByCny[i] > 0) {
                    rows.push({
                        label: `${label}-${o} (${i})`,
                        value: sumByCny[i],
                    });
                }
            });
            return rows;
        },
        getExportFileName() {
            const sd = moment(this.queryParams.PDAT_Start).format('YYYY-MM-DD');
            const ed = moment(this.queryParams.PDAT_End).format('YYYY-MM-DD');
            return `匯款明細(${sd}_${ed})`;
        },
        fetchDataForExport() {
            // 匯出的資料採用全部一次匯出不分頁
            const queryData = { ...this.queryParams };
            queryData.PageSize = 9999;
            queryData.PageNum = 1;

            this.isExporting = true;

            return this.$api({
                url: 'RemittancesDetailPage/GetRemittanceList',
                params: queryData,
                method: 'GET',
            }).finally(() => {
                this.isExporting = false;
            });
        },
        cnyNameToCny(name) {
            const MAP = _.map(cnyName, (label, cny) => ({ name: label, cny }));
            const FOUND = _.find(MAP, ['name', name]);
            return FOUND?.cny || '未知幣別';
        },
        getPaymentTypeName(typeNum) {
            return _.find(paymentType, ['key', typeNum])?.value;
        },
        updateUrlParams() {
            const query = {
                searchDatePreset: this.searchDatePreset,
                ...this.queryParams,
            };

            this.$router.replace({
                name: 'remittances',
                query,
            });
        },
        handlePresetDateChange() {
            if (this.searchDatePreset === 'custom') {
                this.queryDate = [this.queryParams.PDAT_Start, this.queryParams.PDAT_End];
            }
            if (!this.isShowAdvSearch && this.searchDatePreset !== 'custom') {
                this.updateData(true);
            }
        },
        handleDateSpanChange() {
            if (!this.isShowAdvSearch) {
                this.updateData(true);
            }
        },
        handleTypeChange() {
            if (!this.isShowAdvSearch) {
                this.updateData(true);
            }
        },
        handlePaymentDetailDialogClose(paymentChanged) {
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
            if (paymentChanged) {
                this.updateData();
            }
        },
        handleInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        handleFeeBtnClick(fee) {
            console.log(fee);
            this.feeDialog.sno = fee.sno;
            this.feeDialog.amt = fee.feE_AMT;
            this.feeDialog.cny = fee.cnynam;
            this.feeDialog.rat = fee.rat;
            this.feeDialog.visible = true;
        },
        handleSearchBtnClick() {
            this.updateData(true);
        },
        handleFeeDialogClose(refresh) {
            this.feeDialog.visible = false;

            if (refresh) {
                this.updateData();
            }
        },
        handlePaymentItemClick(payment) {
            if (payment) {
                this.paymentDetailDialog.visible = true;
                this.paymentDetailDialog.sno = payment.sno;
            }
        },
        onVariableItemClick(variable) {
            if (variable) {
                this.variableDetailDialog.visible = true;
                this.variableDetailDialog.sno = variable.sno;
            }
        },
        onDetailDialogClose() {
            this.variableDetailDialog.sno = null;
            this.variableDetailDialog.visible = false;
        },
        onEditDialogVisibleChange({ visible, purpose, sno = null }) {
            if (!visible) {
                this.variableEditDialog.purpose = null;
                this.variableEditDialog.sno = null;
            }
            this.variableEditDialog.visible = visible;
            this.variableEditDialog.purpose = purpose;
            this.variableEditDialog.sno = sno;
        },
        onEditDialogRefresh() {
            this.updateData();
            this.$refs.variableDetailDialog.refresh();
        },

        handleInvoiceItemClick(invoice) {
            if (invoice) {
                this.invoiceDetailDialog.visible = true;
                this.invoiceDetailDialog.sno = invoice.sno;
            }
        },
        validDateString(dateString) {
            return /^\d{4}-\d{1,2}-\d{1,2}$/.test(dateString);
        },
        getToday() {
            const NOW = moment();
            const startOfToday = NOW.startOf('day').format('x');
            const endOfToday = NOW.endOf('day').format('x');

            return [startOfToday, endOfToday];
        },
        getThisWeek() {
            const NOW = moment();
            const firstday = NOW.day(0) // 本週的第一天（即星期日）
                .startOf('day')
                .format('x');
            const lastday = NOW.day(6) // 本週的第七天（即星期六）
                .endOf('day')
                .format('x');

            return [firstday, lastday];
        },

        getPrevWeek() {
            const NOW = moment();
            const firstday = NOW.day(0 - 7) // 上週的第一天（即星期日）
                .startOf('day')
                .format('x');
            const lastday = NOW.day(6 - 7) // 上週的第七天（即星期六）
                .endOf('day')
                .format('x');

            return [firstday, lastday];
        },

        getThisMonth() {
            const NOW = moment();
            const firstday = NOW.startOf('month').format('x');
            const lastday = NOW.endOf('month').format('x');

            return [firstday, lastday];
        },

        getPrevMonth() {
            const LAST_MONTH = moment().subtract(1, 'month'); // 從本月扣1個月份
            const firstday = LAST_MONTH.startOf('month').format('x');
            const lastday = LAST_MONTH.endOf('month').format('x');

            return [firstday, lastday];
        },

        applyDateToQueryParams() {
            let days = [0, 0];

            if (this.searchDatePreset === 'today') {
                days = this.getToday();
            } else if (this.searchDatePreset === 'week') {
                days = this.getThisWeek();
            } else if (this.searchDatePreset === 'prevWeek') {
                days = this.getPrevWeek();
            } else if (this.searchDatePreset === 'month') {
                days = this.getThisMonth();
            } else if (this.searchDatePreset === 'prevMonth') {
                days = this.getPrevMonth();
            } else if (this.searchDatePreset === 'custom') {
                days = [moment(_.head(this.queryDate)).startOf('day').format('x'), moment(_.last(this.queryDate)).endOf('day').format('x')];
            }

            this.queryParams.PDAT_Start = Number(_.head(days));
            this.queryParams.PDAT_End = Number(_.last(days));
        },

        updateData(resetPageNum = false) {
            this.isLoading = true;

            if (resetPageNum) this.queryParams.PageNum = 1;

            this.applyDateToQueryParams();
            this.updateUrlParams();

            this.$api({
                url: 'RemittancesDetailPage/GetRemittanceList',
                params: this.queryParams,
                paramsSerializer: (params) => qs.stringify(params, { indices: false, allowDots: true, skipNulls: true }),
                method: 'GET',
            })
                .then((resp) => {
                    console.log('Remittances', resp);

                    // 產生 A B 欄位（置換匯款帳戶）供前端顯示
                    this.datas = this.makeAB(resp.data.items);

                    // 資料總數（頁數換算）
                    this.totalDataCount = resp.data.totalNum;

                    // 統計資訊
                    // 清空
                    this.statisticsInfo.inwardAmount = 0;
                    this.statisticsInfo.outwardAmount = 0;
                    this.statisticsInfo.inwardCurrencyInfos = [];
                    this.statisticsInfo.outwardCurrencyInfos = [];

                    // 給值 (因api回傳資料無分 TYP 都會全顯示, 所以在此限制)
                    if (this.queryParams.TYP === 2 || this.queryParams.TYP === 3) {
                        this.statisticsInfo.inwardAmount = resp.data.statisticsInfo.inwardAmount;
                        this.statisticsInfo.inwardCurrencyInfos = _.filter(resp.data.statisticsInfo.inwardCurrencyInfos, (o) => o.amt);
                    }
                    if (this.queryParams.TYP === 1 || this.queryParams.TYP === 3) {
                        this.statisticsInfo.outwardAmount = resp.data.statisticsInfo.outwardAmount;
                        this.statisticsInfo.outwardCurrencyInfos = _.filter(resp.data.statisticsInfo.outwardCurrencyInfos, (o) => o.amt);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        makeAB(items) {
            const returnValue = items;
            _.forEach(returnValue, (o) => {
                if (this.isPaymentData(o) || this.isVariableData(o)) {
                    // 請款單、殘物單
                    _.set(o, 'A', o.froM_BNK_TPC);
                    _.set(o, 'B', o.tageT_NAM);
                } else {
                    // 發票
                    _.set(o, 'A', o.tageT_NAM);
                    _.set(o, 'B', o.froM_BNK_TPC);
                }
            });

            return returnValue;
        },

        // 判斷
        isInvoiceIncomeData(row) {
            return row.typ === 2 && row.invoiceItems.length;
        },
        isInvoiceRefundData(row) {
            return row.typ === 1 && row.invoiceItems.length;
        },
        isPaymentData(row) {
            return row.typ === 1 && row.payoutItems.length;
        },
        isVariableData(row) {
            return row.variableItems.length;
        },
        isIncome(row) {
            return this.isInvoiceIncomeData(row) || (row.typ === 2 && this.isVariableData(row));
        },
        getShowType(row) {
            // 顯示匯款資訊
            if (this.isBankInfoIntact(row) || this.isInternationalTransfer(row)) return 'bank-info';

            // 顯示「銀行提現付款」
            if (this.isPaymentData(row)) return 'bank-deposit-payment';

            return 'else';
        },
        getCnyText(cny) {
            return cnyName[cny];
        },
        isBankInfoIntact(row) {
            return row.vdR_BNK_TPC && row.targeT_BNK_BOO && row.vdR_BNK_ACC;
        },
        isInternationalTransfer(row) {
            return row.vdR_BNK_TPC && row.vdR_BNK_ACC && !row.targeT_BNK_BOO && !row.targeT_BNK_DOO_NAM;
        },
        isUnknownBnkInfo(row) {
            return (
                (row.targeT_BNK_BOO === '888' && row.targeT_BNK_DOO === '888' && row.vdR_BNK_ACC === '888')
                || (row.targeT_BNK_BOO === '999' && row.targeT_BNK_DOO === '999' && row.vdR_BNK_ACC === '999')
            );
        },
        toggleAdvSearch() {
            this.isShowAdvSearch = !this.isShowAdvSearch;

            if (!this.isShowAdvSearch) {
                // clear
                this.queryParams.MinAmt = null;
                this.queryParams.MaxAmt = null;
                this.queryParams.TargetName = null;
                this.queryParams.BNK_SNO = null;
                this.updateData();
            }
        },
        onSortChange(event) {
            if (event.prop === 'account' && this.queryParams.TYP === 1) this.queryParams.SortProperties.Name = 'froM_BNK_TPC';
            else if (event.prop === 'account' && this.queryParams.TYP === 2) this.queryParams.SortProperties.Name = 'tageT_NAM';
            else if (event.prop === 'others' && this.queryParams.TYP === 1) this.queryParams.SortProperties.Name = 'tageT_NAM';
            else if (event.prop === 'others' && this.queryParams.TYP === 2) this.queryParams.SortProperties.Name = 'froM_BNK_TPC';
            else this.queryParams.SortProperties.Name = event.prop;

            this.queryParams.SortProperties.IsDescending = event.order === 'descending';

            this.updateData();
        },
    },
};
</script>
<style lang="scss" scoped>
.flex-block {
    display: flex;
    .cny {
        width: 55px;
        font-size: 10pt;
    }
}
</style>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.remittances-page {
    .item-container {
        margin-left: 50px;
    }

    .el-date-editor input {
        text-align: center;
    }
    .el-table__expanded-cell,
    .el-table__expanded-cell:hover {
        background-color: #f6f6f6 !important;
    }

    .el-table__expanded-cell {
        .el-table th.is-leaf {
            border-bottom: 1px solid #ccc;
        }
        th {
            background-color: #f6f6f6 !important;
        }
        td {
            background-color: #f6f6f6 !important;
        }

        tr:hover {
            td {
                background-color: #ffffff !important;
            }
        }
    }
    .pagination.top {
        text-align: right;
        padding: 10px 0;
    }
}
</style>
